import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Box, Button, Checkbox, Chip, CircularProgress, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { AssistantPhoto, ManageSearchSharp } from '@mui/icons-material'
import axios from 'axios'
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import { convertToRaw } from 'draft-js';
import { useHistory } from 'react-router-dom';
import { PhotoCamera, AddTwoTone } from '@mui/icons-material';
import ClearIcon from '@mui/icons-material/Clear';
import { HourglassTopRounded } from '@mui/icons-material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SimpleImageSlider from "react-simple-image-slider";
import slugify from 'slugify'
import Header from '../components/Header'
import ManageCategoriesComp from '../components/ManageCategoriesComp';
import ManageMacroIndicatorsComp from '../components/ManageMacroIndicatorsComp'

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { useStore } from '../store/StoredData';
import FinancialTableComp from '../components/FinancialTableComp';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import InternalLinkSearchComp from '../components/InternalLinkSearchComp';
import ReactDatePicker from 'react-datepicker';
import format from 'date-fns/format';
import { showCustomToast } from '../CustomToast';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 3;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


const priorityList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const weightList = [1, 2, 3, 4, 5]

const AddArticle = () => {

    const history = useHistory();
    const { currentUser, setCurrentUser,
        masterCategoriesSubCategoriesTree, setMasterCategoriesSubCategoriesTree, initDateRange, selectDateRange
    } = useStore();

    const [startDate, setStartDate] = useState(new Date());
    const [loading, setLoading] = useState(false)
    const [author, setAuthor] = useState(JSON.parse(localStorage.getItem('user')).first_name)
    const [articleTitle, setArticleTitle] = useState("")
    const [articleSummary, setArticleSummary] = useState("")
    const [titleSlug, setTitleSlug] = useState("")
    const [articleDescriptionState, setArticleDescriptionState] = useState("");
    const [convertedContentArticleDescription, setConvertedContentArticleDescription] = useState('');
    const [selectedPriority, setSelectedPriority] = useState('');
    const [selectedWeight, setSelectedWeight] = useState(3);
    const [isFeatured, setIsFeatured] = useState(false)
    const [masterCategories, setMasterCategories] = useState([])
    const [masterSubCategories, setMasterSubCategories] = useState([])
    const [assignedMasterCategoriesSubCategoriesTree, setAssignedMasterCategoriesSubCategoriesTree] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [selectedCategoryList, setSelectedCategoryList] = useState([])
    const [selectedSubCatList, setSelectedSubCatList] = useState([])
    const [articleVersion, setArticleVersion] = useState('');
    const [articlePhoto, setArticlePhoto] = useState([])
    const [articlePictureFile, setArticlePictureFile] = useState()
    const [imageAltTag, setImageAltTag] = useState("")
    const [imageCaption, setImageCaption] = useState("")
    const [imageList, setImageList] = useState([
        // { url: "images/1.jpg" },
    ]);
    const [openCategoryModal, setOpenCategoryModal] = useState(false)
    const [openIndicatorsModal, setOpenIndicatorsModal] = useState(false)

    const [location, setLocation] = useState("")
    const [locationList, setLocationList] = useState([])
    const [locationSuggestion, setLocationSuggestions] = useState([]);
    const [locationSuggDropDownState, setLocationSuggDropDownState] = useState(false);
    const [locationSuggLoading, setLocationSuggLoading] = useState(false);

    const [peopleNames, setPeopleNames] = useState("")
    const [peopleNamesList, setPeopleNamesList] = useState([])
    const [peopleSuggestion, setPeopleSuggestions] = useState([]);
    const [peopleSuggDropDownState, setPeopleSuggDropDownState] = useState(false);
    const [peopleSuggLoading, setPeopleSuggLoading] = useState(false);

    const [industry, setIndustry] = useState("")
    const [industryList, setIndustryList] = useState([])
    const [industrySuggestion, setIndustrySuggestions] = useState([]);
    const [industrySuggDropDownState, setIndustrySuggDropDownState] = useState(false);
    const [industrySuggLoading, setIndustrySuggLoading] = useState(false);

    const [company, setCompany] = useState("")
    // const [associatedCompanies, setAssociatedCompanies] = useState([])
    const [companyList, setCompanyList] = useState([])
    const [companySuggestion, setCompanySuggestions] = useState([]);
    const [companySuggDropDownState, setCompanySuggDropDownState] = useState(false);
    const [companySuggLoading, setCompanySuggLoading] = useState(false);

    const [tickersList, setTickersList] = useState([]);

    const [assignedMasterMacroIndicatorTree, setAssignedMasterMacroIndicatorTree] = useState([]);
    const [selectedMacroIndicator, setSelectedMacroIndicator] = useState();
    const [selectedMacroIndicatorList, setSelectedMacroIndicatorList] = useState([])
    const [selectedMacroSubIndicatorList, setSelectedMacroSubIndicatorList] = useState([])
    const [isArticleIndexable, setIsArticleIndexable] = useState(false)
    const [imageType, setImageType] = useState("")
    const [imageCredit, setImageCredit] = useState("")

    const [articleDescription, setArticleDescription] = useState("");
    const quillRef = useRef();


    const [dateRange, setDateRange] = useState(initDateRange);
    const [searchKeywords, setSearchKeywords] = useState([])
    const [searchCompany, setSearchCompany] = useState([])
    const [searchByCategoryId, setSearchByCategoryId] = useState([])
    const [searchBySubCategoryId, setSearchBySubCategoryId] = useState([])
    const [authorList, setAuthorList] = useState([])
    const [searchByAuthor, setSearchByAuthor] = useState([])
    const [searchArticleLoading, setSearchArticleLoading] = useState(false)

    const [searchResultArticles, setSearchResultArticles] = useState([])
    const [editorsSelectedArticles, setEditorsSelectedArticles] = useState([])
    const [editorsSelectedArticlesId, setEditorsSelectedArticlesId] = useState([])

    // ***** CREATE AD & NEWSLETTER SECTION STATE *****
    const [editorPicFile, setEditorPicFile] = useState(null)
    // Hardcoded digest types - replace with API call when backend is ready
    const [digestTypesList] = useState([
        { id: 1, name: "Daily Digest-INLINE article 1match page" }
    ])
    const [selectedDigestType, setSelectedDigestType] = useState({ id: 1, name: "Daily Digest" })
    const [freeSignupText, setFreeSignupText] = useState(() => localStorage.getItem('newsletter_draft_freeSignupText') || "")
    const [signUpLinkText, setSignUpLinkText] = useState(() => localStorage.getItem('newsletter_draft_signUpLinkText') || "")
    const [confirmationPopupText, setConfirmationPopupText] = useState(() => localStorage.getItem('newsletter_draft_confirmationPopupText') || "")
    const [prospectsList, setProspectsList] = useState([])
    const [selectedProspects, setSelectedProspects] = useState([])
    const [openPublishAdSuccessModal, setOpenPublishAdSuccessModal] = useState(false)
    const [newsLetterId, setNewsLetterId] = useState([])
    const [nonMemberPopUpID, setnonMemberPopUpID] = useState([])
    const [nonMemIsDisabled, setnonMemSetIsDisabled] = useState(false);
    const [createAdDisabled, setCreateAdSetDisabled] = useState(false);

    // ***** PERSIST NEWSLETTER DRAFT TO LOCALSTORAGE *****
    useEffect(() => {
        localStorage.setItem('newsletter_draft_freeSignupText', freeSignupText);
    }, [freeSignupText]);

    useEffect(() => {
        localStorage.setItem('newsletter_draft_signUpLinkText', signUpLinkText);
    }, [signUpLinkText]);

    useEffect(() => {
        localStorage.setItem('newsletter_draft_confirmationPopupText', confirmationPopupText);
    }, [confirmationPopupText]);

    // ***** NON-MEMBER POPUP SECTION STATE *****
    const [nmAdTypesList] = useState([
        { id: 1, name: "INLINE article-Internal ad for tab, 1match page of an article" },
        { id: 2, name: "Homepage & Tab Resolution Ads" }
    ])
    const [nmTabsList] = useState([
        { id: 1, name: "Editors" },
        { id: 2, name: "Daily Digest" },
        { id: 3, name: "Weekly Digest" },
        { id: 4, name: "Special Edition" }
    ])
    const [selectedNmAdType, setSelectedNmAdType] = useState(null)
    const [selectedNmTab, setSelectedNmTab] = useState(null)
    const [nmEditorMessage, setNmEditorMessage] = useState(() =>
        localStorage.getItem('nm_popup_draft_editorMessage') ||
        `<Editor Name> "I'm tracking the <Industry Trend> all week. Enter your email and I'll send you my final report this Friday." (Default Editor's message)`
    )
    const [nmCtaButtonText, setNmCtaButtonText] = useState(() =>
        localStorage.getItem('nm_popup_draft_ctaButtonText') || "Get the report"
    )
    const [nonMemData, setNonMemData] = useState([])

    console.log("author",author)

    useEffect( () => {
        const fetchEditorProfile = async () => {
        try {
            console.log("Inside the method to fetch the editor details")
                const response = await axios.get(`/api/v3/articles/searchEditor/${author}`);
                console.log('Search API RESP === ', response.data.message);
                if(response.data.sucess){                    
                    setEditorPicFile(response.data.message.profile_image_url)
                    setAuthor(response.data.message.editor_name)
                }
                
            } catch (error) {
                console.error('Error fetching API data:', error);
                // setEditorPicFile(null)
            }
            };
            fetchEditorProfile();
    },[author])
    
    useEffect(()=>{
        console.log("assignedMasterCategoriesSubCategoriesTree:::",assignedMasterCategoriesSubCategoriesTree);
        let catId,subCatId;
        assignedMasterCategoriesSubCategoriesTree.map(category=>{
            if(category.isChecked){
               catId=category.cat_id;
               console.log("catId",catId);
               if(category.subcats && category.subcats.length > 0) {
                    category.subcats.map(subcat =>{
                        if(subcat.isChecked){
                            subCatId=subcat.sub_cat_id;
                            console.log("subCatId",subCatId);
                        }
                    });
               }
            }
        });
        console.log("catId-subCatId",catId,"-",subCatId);
        if (catId) {
            axios.get(`/api/v3/nonMemberPopupandAds/${catId}`).then(resp => {
                    setNonMemData(resp.data.message)
                    console.log("data fetched---",resp.data.message,"----",resp.data.message.NonMemDetails,"-----",resp.data.message.AdNewsLettDetails);
                    if (resp.data.message.NonMemDetails) {
                        setNmEditorMessage(resp.data.message.NonMemDetails.editor_message)
                        setNmCtaButtonText(resp.data.message.NonMemDetails.cta_text)
                    }
                    if(resp.data.message.AdNewsLettDetails){
                        setFreeSignupText(resp.data.message.AdNewsLettDetails.signup_text)
                        setSignUpLinkText(resp.data.message.AdNewsLettDetails.signup_link)
                        setConfirmationPopupText(resp.data.message.AdNewsLettDetails.confirmation_text)
                    }
                }).catch(err => console.log("Error ", err))
        }
        console.log("data fetched-",nonMemData);            
    },[assignedMasterCategoriesSubCategoriesTree])

    // ***** PERSIST NON-MEMBER POPUP DRAFT TO LOCALSTORAGE *****
    useEffect(() => {
        localStorage.setItem('nm_popup_draft_editorMessage', nmEditorMessage);
    }, [nmEditorMessage]);

    useEffect(() => {
        localStorage.setItem('nm_popup_draft_ctaButtonText', nmCtaButtonText);
    }, [nmCtaButtonText]);

    const COMPANY_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "company" must be in lower case Followed by "/" \n
The ticker must be always in UPPERCASE. example "AAPL" not "aapl" or "Aapl" etc. \n
Final Internal Link format must be like this - "/company/<TICKER>". example: "/company/AAPL"
`;

    const PEOPLE_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "people" must be in lower case Followed by "/" \n
The person slug must always start with person_id, then person name as slug, separated by "-". example "123456-bill-gates" \n
Final Internal Link format must be like this - "/people/<person_id-person_slug>". example: "/people/123456-bill-gates"
`;

    const ARTICLE_PAGE_RULES = `
Always start with "/" \n
Do not include website base url: example - https://candorium.com \n
The resource path "news" must be in lower case Followed by "/" \n
The article_id must always be a Number,then followed by "/" \n
Then followed by article_slug. example "2025123123595/apple-releases-new-iphone-15" \n
The article slug part must not contain any special characters such as - "% , | . ? ' " #" \n
Final Internal Link format must be like this - "/news/<article_id/article_slug>". example: "/news/20251231235959999/apple-releases-new-iphone-15"
`;

    const HTTPS_URL_RULES = `
Always start with "https://" \n
Domain must contain letters/numbers/hyphens separated by dots \n
Must end with top-level domain of 2+ letters (.com, .org, etc.) \n
Subdomains are allowed (www, blog, etc.) \n
Optional path can contain any non-whitespace characters \n
No spaces allowed anywhere in the URL \n
Examples: "https://example.com", "https://sub.domain.org/path?query=value"
`;
    const validateInternalLink = (url) => {
        if (typeof url !== "string" || !url.trim()) return false;

        const trimmedUrl = url.trim();

        // Define Patterns
        const httpsPattern = /^https:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/\S*)?$/;
        const companyPattern = /^\/company\/[A-Z]+$/;
        const peoplePattern = /^\/people\/\d{4,}-[a-z-]+$/;
        const newsPattern = /^\/news\/\d{8,}\/[\w-]+$/;

        // External Links
        if (trimmedUrl.startsWith("https://")) {
            return httpsPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_https';
        }

        // Internal links
        if (trimmedUrl.startsWith("/company/")) {
            return companyPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_company';
        }

        if (trimmedUrl.startsWith("/people/")) {
            return peoplePattern.test(trimmedUrl) ? trimmedUrl : 'invalid_people';
        }

        if (trimmedUrl.startsWith("/news/")) {
            return newsPattern.test(trimmedUrl) ? trimmedUrl : 'invalid_news';
        }

        return false;
    };



    useEffect(() => {
        if (quillRef.current) {
            const quill = quillRef.current.getEditor();
            // Theme is 'snow' by default, and tooltip is part of the theme
            const tooltip = quill.theme.tooltip;

            // Save the original save method
            const originalSave = tooltip.save;

            // Override the save method to add validation
            tooltip.save = function () {
                const linkUrl = this.textbox.value;

                // Validate the link
                const validationResult = validateInternalLink(linkUrl);

                // Check if validation was successful (returns the URL string)
                if (typeof validationResult === 'string' && !validationResult.startsWith('invalid_')) {
                    // Apply the validated link
                    this.textbox.value = validationResult;
                    return originalSave.call(this);
                }

                // Handle specific validation errors
                let errorMessage = "Invalid link format.";

                if (validationResult === 'invalid_https') {
                    errorMessage = "❌ Invalid link format. Must start with https://. \n" + HTTPS_URL_RULES;
                } else if (validationResult === 'invalid_company') {
                    errorMessage = "❌ Invalid Company link format. Tickers must be uppercase (e.g., /company/AAPL).\n" + COMPANY_PAGE_RULES;
                } else if (validationResult === 'invalid_people') {
                    errorMessage = "❌ Invalid People link format. Must be like /people/ID-slug (e.g., /people/1234-john-doe). \n" + PEOPLE_PAGE_RULES;
                } else if (validationResult === 'invalid_news') {
                    errorMessage = "❌ Invalid News link format. Must be like /news/YYYYMMDD.../slug (e.g., /news/2025010100001/apple-launches-iphone). \n" + ARTICLE_PAGE_RULES;
                } else {
                    // For false (unknown prefix or completely invalid)
                    errorMessage = "❌ Link must be a valid internal path, starting with https://, /company/, /people/, or /news/."
                }

                alert(errorMessage);
                return false; // Prevent saving
            };

            // Cleanup on component unmount
            return () => {
                if (tooltip && originalSave) {
                    tooltip.save = originalSave;
                }
            };
        }
    }, []);

    // 🧰 Quill toolbar configuration
    const modules = {
        toolbar: {
            container: [
                [{ header: [1, 2, 3, 4, 5, false] }],
                ["bold", "italic", "underline", "strike", "blockquote",],
                // [{ color: [] }, { background: [] }],
                [{ script: "sub" }, { script: "super" }],
                [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
                [{ align: [] }],
                ["link"],
                // ["link", "image", "video"],
                // ["clean"],
            ],
            handlers: {
                // link: handleAddLink,
            },
        },
        clipboard: { matchVisual: false },
    };

    // 🖋️ Quill formats (needed to allow these features)
    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        "list",
        "bullet",
        "indent",
        "link",
        "image",
        "video",
        "color",
        "background",
        "align",
        "script",
    ];

    const handleChange = (content, delta, source, editor) => {
        setArticleDescription(content);
        // console.log("content :::", content)
    };


    const handleMacroIndicatorChange = async (e, indicator, selectedcategory) => {
        console.log('Selected CAT', selectedcategory, 'Indicator Value ::: ', indicator, 'EVENT ::: ', e.target.checked);
        let mVal = assignedMasterMacroIndicatorTree.map(cat => {
            if (cat.category_id === selectedMacroIndicator.category_id) {
                let fsc = cat.indicators.map(ind => {
                    if (ind.indicator_id === indicator.indicator_id) {
                        return { ...ind, isChecked: !ind.isChecked };
                    }
                    return ind;
                })
                setSelectedMacroSubIndicatorList(fsc.filter(f => f.isChecked));
                let someSelectedIndicators = fsc.some(obj => obj.isChecked);
                someSelectedIndicators ? cat.isChecked = true : cat.isChecked = false;
                return { ...cat, indicators: fsc };
            }
            return cat;
        });
        setAssignedMasterMacroIndicatorTree(mVal);
        setSelectedMacroIndicator(mVal.filter(cat => cat.category_id === selectedcategory.category_id)[0]);
    };

    const handleAssignMacroIndicator = () => {
        let fCats = assignedMasterMacroIndicatorTree
            .filter(cat => cat.isChecked === true)
            .map(cat => ({ ...cat, indicators: cat.indicators.filter(ind => ind.isChecked === true) }))
        console.log('Final Filtered ASSIGNED MACRO INDICATORS :::::: ', fCats);
        setSelectedMacroIndicatorList(fCats);
    }

    const handleEditorArticleDescription = (state) => {
        if (state) {
            setArticleDescriptionState(state);
            convertContentToHTMLArticleDescription();
        }
    }

    const convertContentToHTMLArticleDescription = () => {
        let currentContentAsHTML = draftToHtml(convertToRaw(articleDescriptionState.getCurrentContent()));
        setConvertedContentArticleDescription(currentContentAsHTML);
    }

    const updateSubCategoriesList = async (category) => {
        // setMasterSubCategories([]);
        // setSelectedSubCategory(null);
        // let filteredCat = assignedMasterCategoriesSubCategoriesTree.filter(obj => parseInt(obj.cat_id) === parseInt(category.id));
        // console.log('Filtered Sub Categories List ::::: ', filteredCat)
        // if (filteredCat.length)
        //     setMasterSubCategories(filteredCat[0].subcats.map((s) => ({ ...s, isChecked: false })))

        // setSelectedCategory(category);
        // setAssignedMasterCategoriesSubCategoriesTree(prev => {
        //     return prev.map(obj => {
        //         if (obj.cat_id === category.cat_id) {
        //             return { ...obj, isChecked: true }
        //         } else {
        //             return obj;
        //         }
        //     })
        // })
    };


    useEffect(() => {
        setLoading(true);
        const fetchCategories = async () => {
            console.log('Calling Categories API...');
            await axios.get("/api/categories").then(async resp => {
                console.log('RECVD FROM API Master Categories ::: ', resp.data);
                if (resp.data.message.length)
                    setMasterCategories(resp.data.message)
            }).catch(console.error)
        };
        const fetchSubCategories = async () => {
            console.log('Calling Categories API...');
            await axios.get("/api/sub-categories").then(async resp => {
                console.log('RECVD FROM API Master Sub Categories ::: ', resp.data.message);
                if (resp.data.message.length)
                    setMasterSubCategories(resp.data.message)
            }).catch(console.error)
        };
        const fetchCategoriesSubCategoriesMapping = async () => {
            console.log('Calling Categories API...');
            await axios.get("/api/categories-subcategories").then(async resp => {
                console.log('RECVD FROM API Categories & Sub Categories Mapping ::: ', resp.data.message);
                if (resp.data.message.length) {
                    setMasterCategoriesSubCategoriesTree(resp.data.message);
                    let data = resp.data.message.map(cats => {
                        let mapped = cats.subcats.map(obj => {
                            return { ...obj, isChecked: false };
                        });
                        return { ...cats, isChecked: false, subcats: mapped };
                    })
                    setAssignedMasterCategoriesSubCategoriesTree(data);
                }
            }).catch(console.error)
        };

        const fetchMasterMacroIndicatorTree = () => {
            axios.get(`/api/master-macro-indicators-tree`)
                .then(async (resp) => {
                    console.log("master-macro-indicators-tree :::", resp.data.message);
                    // setMasterIndicatorSubTree(resp.data.message)
                    let data = await resp.data.message.map(cats => {
                        let mapped = cats.indicators.map(obj => {
                            return { ...obj, isChecked: false };
                        });
                        return { ...cats, isChecked: false, indicators: mapped };
                    });

                    // if (articleContent.macro_indicators)
                    //     for (const obj of articleContent.macro_indicators) {
                    //         data.map(o => {
                    //             if (obj.category_id === o.category_id) {
                    //                 o.isChecked = true;
                    //                 for (const ind of obj.indicators) {
                    //                     o.indicators.filter(x => x.indicator_id === ind.indicator_id).map(y => {
                    //                         y.isChecked = true;
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //     };
                    console.log('MAPPED MACRO INDICATORS DATA :::: ', data);
                    setAssignedMasterMacroIndicatorTree(data);
                }).catch((err) => console.log("Error :::", err))
        }

        fetchCategories();
        fetchSubCategories();
        fetchCategoriesSubCategoriesMapping();
        fetchMasterMacroIndicatorTree();
        setLoading(false);

        return () => clearImmediate();;

    }, [])

    useEffect(() => {
        const fetchCategoriesSubCategoriesMapping = async () => {
            console.log('Calling Categories API...');
            await axios.get("/api/categories-subcategories").then(async resp => {
                console.log('RECVD FROM API Categories & Sub Categories Mapping ::: ', resp.data.message);
                if (resp.data.message.length)
                    setMasterCategoriesSubCategoriesTree(resp.data.message);
            }).catch(console.error)
        };

        fetchCategoriesSubCategoriesMapping();

        return () => clearImmediate();

    }, []);


    const saveArticle = async () => {
        setLoading(true);
        let formData = new FormData();

        formData.append("is_article_indexable", isArticleIndexable)
        formData.append("title", articleTitle)
        formData.append("summary", articleSummary)
        formData.append("title_slug", titleSlug)
        formData.append("image_alt_text", imageAltTag)
        formData.append("image_caption_text", imageCaption)
        // formData.append("description", convertedContentArticleDescription)
        formData.append("description", articleDescription)
        formData.append("author_name", author)
        formData.append("author_id", currentUser.userid)
        formData.append("date", new Date(startDate).toISOString())
        formData.append("item_version", articleVersion)
        formData.append("news_priority", selectedPriority)
        formData.append("is_featured", isFeatured)
        formData.append("weight", Number(selectedWeight) || 3)
        formData.append("news_type", "News Desk")
        formData.append("content_type", "image")
        formData.append("image_type", imageType)
        formData.append("image_credit", imageCredit)
        console.log("Internal Ad text:::",freeSignupText, newsLetterId)
        formData.append("freeSignupText" ,freeSignupText)
        formData.append("newsletterID",newsLetterId)
        console.log("Non Member Popup:::", nonMemberPopUpID)
        formData.append("nonMemberPopUpID",nonMemberPopUpID)
        // selectedCategoryList.length > 0
        //     ? selectedCategoryList.forEach(cat => formData.append("assigned_cats_subcats", JSON.stringify({ cat_id: cat.cat_id, cat_name: cat.cat_name, subcats: cat.subcats?.map(sc => ({ sub_cat_id: sc.sub_cat_id, sub_cat_name: sc.sub_cat_name })) })))
        //     : formData.append("assigned_cats_subcats", '')

        let fCats = assignedMasterCategoriesSubCategoriesTree.filter(x => x.isChecked)
        let fAssignedCats = [], MasterCatIds = [], MasterSubCatIds = [];
        for await (const cat of fCats) {
            console.log('F CAT = ', cat)
            MasterCatIds.push(cat.cat_id)
            let fsc = cat.subcats.filter(x => x.isChecked)
            fsc.map(x => MasterSubCatIds.push(x.sub_cat_id))
            console.log('F SUB-CAT = ', fsc)
            fAssignedCats.push({ ...cat, subcats: fsc })
        }
        console.log('F fAssignedCats = ', fAssignedCats, MasterCatIds, MasterSubCatIds)
        fAssignedCats.forEach(a => formData.append("assigned_cats_subcats", JSON.stringify(a)))
        MasterCatIds.forEach(x => formData.append("master_category_ids", x))
        MasterSubCatIds.forEach(x => formData.append("master_subcategory_ids", x))

        locationList.length ? locationList.map(o => formData.append("places", JSON.stringify(o))) : formData.append("places", '');
        peopleNamesList.length ? peopleNamesList.map(o => formData.append("people", JSON.stringify(o))) : formData.append("people", '');
        industryList.length ? industryList.map(o => formData.append("industry", JSON.stringify(o))) : formData.append("industry", '');
        companyList.length ? companyList.map(o => formData.append("company", o)) : formData.append("company", '');
        // associatedCompanies.length ? associatedCompanies.map(o => formData.append("company", o)) : formData.append("company", '');
        tickersList.length ? tickersList.map(o => formData.append("tickers", o)) : formData.append("tickers", tickersList);
        selectedMacroIndicatorList.length ? selectedMacroIndicatorList.map(o => formData.append("macro_indicators", JSON.stringify(o))) : formData.append("macro_indicators", '');
        imageList.length ? imageList.map(o => formData.append("article_photo", o.file)) : formData.append("article_photo", '');
        editorsSelectedArticlesId.length ? editorsSelectedArticlesId.map(o => formData.append("editor_related_articles", o)) : formData.append("editor_related_articles", '');

        formData.forEach(d => console.log('Final FORM Data ::: ', d));

        await axios({
            method: 'POST',
            url: '/api/v2/article',
            headers: { 'Content-Type': 'multipart/form-data; boundary="boundary"' },
            data: formData
        }).then(resp => {
            alert(`News Article Saved Successfully!\nNews Article ID - ${JSON.stringify(resp.data.message.id)}`)
            history.push('/home')
        }).catch(error => {
            console.log('API ERROR ::: ', error.response.data);
            alert(`${JSON.stringify(error.response.data.message)}`)
        }).finally(() => setLoading(false))
    }


    const uploadProfilePicture = async (e) => {
        e.preventDefault();

        let data = new FormData();
        data.append('image_for', 'profile');
        // data.append('array_index', null)
        data.append('picture_path', e.target.files[0]);
        // setArticlePhoto(e.target.files[0])
        setArticlePictureFile(URL.createObjectURL(e.target.files[0]))

        for (let i = 0; i <= e.target.files.length; i++) {
            imageList.push({ url: URL.createObjectURL(e.target.files[i]), name: e.target.files[i].name, file: e.target.files[i] })
        }

        data.forEach(d => console.log('FILE UPLOAD DATA ::::::: ', d))
    };

    // console.log("Image List / Article Photo:::", imageList);

    const handleSubCatList = (event) => {
        const { value } = event.target;
        // console.log("Checkbox Selected Val before ::: ", value)
        value[0].isChecked = !value[0].isChecked;
        // console.log("Checkbox Selected Val", value)
        setSelectedSubCatList(value);
    }

    const handleCatChange = async (val) => {
        console.log('Recieved CAT to Update === ', val)
        let mVal = assignedMasterCategoriesSubCategoriesTree.map(cat => cat.cat_name === selectedCategory.cat_name)
        setAssignedMasterCategoriesSubCategoriesTree(mVal)
        const nVal = assignedMasterCategoriesSubCategoriesTree.filter(x => x.cat_name === val)
        setSelectedCategory(nVal[0])
    }

    const handleSubCatChange = async (e, subCatObj, selectedcategory) => {
        console.log('Selected CAT', selectedcategory, 'SUB-CAT Value ::: ', subCatObj, 'EVENT ::: ', e.target.checked);
        let mVal = assignedMasterCategoriesSubCategoriesTree.map(cat => {
            if (cat.cat_id === selectedCategory.cat_id) {
                let fsc = cat.subcats.map(subcat => {
                    if (subcat.sub_cat_id === subCatObj.sub_cat_id) {
                        return { ...subcat, isChecked: !subcat.isChecked };
                    }
                    return subcat;
                });
                setSelectedSubCatList(fsc.filter(f => f.isChecked));
                let someSelectedSubCats = fsc.some(obj => obj.isChecked);
                someSelectedSubCats ? cat.isChecked = true : cat.isChecked = false;
                return { ...cat, subcats: fsc };
            }
            return cat;
        });
        setAssignedMasterCategoriesSubCategoriesTree(mVal);
        setSelectedCategory(mVal.filter(cat => cat.cat_id === selectedcategory.cat_id)[0]);
    };

    const handleAssignCategories = () => {
        let fCats = assignedMasterCategoriesSubCategoriesTree
            .filter(cat => cat.isChecked === true)
        // .map(cat => ({ ...cat, subcats: cat.subcats.filter(subcat => subcat.isChecked === true) }))
        console.log('FINAL FILTERED ASSIGNED CATS & SUB-CATS :::::: ', assignedMasterCategoriesSubCategoriesTree, fCats, selectedCategory);
        setSelectedCategoryList(fCats);
    }


    // console.log("MAster Subcate", masterSubCategories);
    // console.log("SubCatLIst", subCatList);
    // console.log('FINAL ASSIGNED CAT, SUB-CATS :::: ', selectedCategoryList);
    // console.log('assignedMasterCategoriesSubCategoriesTree =', assignedMasterCategoriesSubCategoriesTree)

    const handleLocationList = (selectedLocation) => {
        console.log("selected Location :::", selectedLocation);
        setLocationList(prev => [...prev, selectedLocation])
    }

    const handleDeleteLocation = (loc) => {
        console.log("Deleting Location :::", loc)
        setLocationList(locationList.filter(location => location.name !== loc.name))
    }
    const handlePeopleNamesList = (selectedPeople) => {
        setPeopleNamesList(prev => [...prev, selectedPeople])
    }

    const handleDeletePeople = (ppl) => {
        console.log("Deleting People :::", ppl)
        setPeopleNamesList(peopleNamesList.filter(people => people.name !== ppl.name))
    }

    const handleIndustryList = (selectedIndustry) => {
        console.log('Selected Industry === ', selectedIndustry)
        setIndustryList(prev => [...prev, { code: selectedIndustry.sic_grp_code, name: selectedIndustry.sic_grp_name }])
    }

    const handleDeleteIndustry = (ind) => {
        console.log("Deleting Industry :::", ind)
        setIndustryList(industryList.filter(industry => industry.code !== ind.code))
    }

    // console.log('INDUSTRIES ::: ', industryList);

    const handleCompanyList = (selectedCompany) => {
        console.log('Selected Company === ', selectedCompany)
        setCompanyList(prev => [...prev, selectedCompany.name])
        // setAssociatedCompanies(prev => [...prev, selectedCompany])
        console.log('RECVD TICKER ::: ', selectedCompany.ticker);
        setTickersList(prev => [...prev, selectedCompany.ticker ? selectedCompany.ticker : ''])
    }

    // console.log("Associated Company List :::", associatedCompanies)
    const handleDeleteCompany = (comp) => {
        console.log("Deleting Company & Ticker :::", comp)
        setCompanyList(companyList.filter(company => company !== comp))
        if (tickersList.length)
            setTickersList(prev => prev.filter(o => o !== comp.ticker))
        // setAssociatedCompanies(prev => prev.filter(o => o.cik !== comp.cik))
    }

    // console.log('Company List ::: ', companyList);
    // console.log('Tickers List ::: ', tickersList);

    const handlePeopleData = (inputData) => {
        if (inputData.length > 2) {
            setPeopleSuggLoading(true);
            setPeopleSuggestions([]);
            axios.get('/api/person', { params: { s: inputData } }).then((resp) => {
                setPeopleSuggDropDownState(true);
                setPeopleSuggestions(resp.data.message);
                setPeopleSuggLoading(false);
            });
        } else {
            setPeopleSuggestions([]);
            setPeopleSuggDropDownState(false);
        }
    };

    const handleIndustryTypeahead = (inputData) => {
        if (inputData.length > 2) {
            setIndustrySuggLoading(true);
            setIndustrySuggestions([]);
            axios.get('/api/industries', { params: { s: inputData } }).then((resp) => {
                setIndustrySuggDropDownState(true);
                setIndustrySuggestions(resp.data.message);
                setIndustrySuggLoading(false);
            });
        } else {
            setIndustrySuggestions([]);
            setIndustrySuggDropDownState(false);
        }
    };

    const handleCompanyTypeahead = (inputData) => {
        if (inputData.length > 2) {
            setCompanySuggLoading(true);
            setCompanySuggestions([]);
            axios.get('/api/companies', { params: { s: inputData } }).then((resp) => {
                setCompanySuggDropDownState(true);
                setCompanySuggestions(resp.data.message);
                setCompanySuggLoading(false);
            });
        } else {
            setCompanySuggestions([]);
            setCompanySuggDropDownState(false);
        }
    };

    const debounce = (func) => {
        let timer;
        return function (...args) {
            const context = this;
            if (timer) clearTimeout(timer);
            timer = setTimeout(() => {
                timer = null;
                func.apply(context, args);
            }, 400);
        };
    };

    const optimizedPeopleFn = useCallback(debounce(handlePeopleData), []);
    const optimizedIndustryeFn = useCallback(debounce(handleIndustryTypeahead), []);
    const optimizedCompanyFn = useCallback(debounce(handleCompanyTypeahead), []);

    useEffect(() => {
        // let slug = articleTitle.toLowerCase().replace(/[^a-z^A-Z^0-9^$^.^\s+]/gmi, '').replace(/\$/gm, 'dollar').replace(/\%/gm, 'percent').replace(/\s/gmi, '-')
        // Use slugify to generate a SEO-friendly URL slug
        // Custom slugify to preserve numbers, dots, and replace $/% with words
        let slug = slugify(articleTitle, {
            lower: true,
            strict: false,
            trim: true,
            remove: /[^a-zA-Z0-9.\-$%\s]/g, // allow . $ % and spaces
            replacement: (match) => {
                if (match === '$') return 'dollar-';
                if (match === '%') return '-percent';
                return '-';
            },
        })
        setTitleSlug(slug);
    }, [articleTitle])


    const handleDateRange = (currDt) => {
        setDateRange(prvDt => {
            if (prvDt === currDt) {
                selectDateRange(currDt);
                return currDt
            } else {
                selectDateRange(currDt);
                return currDt
            }
        });
    }
    



    const handleSearchArticle = async () => {
        console.log({ searchByAuthor, searchByCategoryId, searchBySubCategoryId, searchCompany, searchKeywords, dateRange })
        if (searchByAuthor || searchByCategoryId || searchBySubCategoryId || searchCompany || searchKeywords || dateRange) {
            setSearchArticleLoading(true);
            try {
                const response = await axios.get(`/api/v3/articles/search`, {
                    params: {
                        author: searchByAuthor,
                        categoryId: searchByCategoryId,
                        subCategoryId: searchBySubCategoryId,
                        company: searchCompany,
                        keywords: searchKeywords,
                        startdate: format(dateRange[0], "yyyy-MM-dd"),
                        enddate: format(dateRange[1], "yyyy-MM-dd"),
                    }
                });
                console.log('Search API RESP === ', response.data.message);
                setSearchResultArticles(response.data.message.rows);
                setSearchArticleLoading(false);
            } catch (error) {
                console.error('Error fetching API data:', error);
                setSearchArticleLoading(false);
            }
        }
    }


    const handleArticleSelect = (articleId) => {
        setEditorsSelectedArticlesId((prevSelected) => {
            if (prevSelected.includes(articleId)) {
                // If already selected, remove it
                return prevSelected.filter((id) => id !== articleId);
            } else {
                // If not selected, add it
                return [...prevSelected, articleId];
            }
        });
    };

    const handleSelectedArticles = () => {
        if (editorsSelectedArticlesId.length > 0) {
            let filterArticles = searchResultArticles.filter((article) => editorsSelectedArticlesId.includes(article.article_id));
            console.log("Selected Articles>>>", filterArticles)
            setEditorsSelectedArticles(filterArticles);
            // setSearchResultArticles([])
        }
    }

    const handleRemoveRelatedArticle = (articleId) => {
        setEditorsSelectedArticlesId((prevSelected) => prevSelected.filter((id) => id !== articleId));
        setEditorsSelectedArticles((prevSelected) => prevSelected.filter((article) => article.article_id !== articleId));
    }

    // ***** CREATE AD & NEWSLETTER SECTION HANDLERS *****
    const handleUploadEditorPic = async (e) => {
        e.preventDefault();
        
        let data = new FormData();
        data.append('image_for', 'profile');
        // data.append('array_index', null)
        data.append('picture_path', e.target.files[0]);
        // setArticlePhoto(e.target.files[0])
        setEditorPicFile(URL.createObjectURL(e.target.files[0]))

        for (let i = 0; i <= e.target.files.length; i++) {
            imageList.push({ url: URL.createObjectURL(e.target.files[i]), name: e.target.files[i].name, file: e.target.files[i] })
        }
    }

    const handleAddProspect = (prospect) => {
        if (selectedProspects.length >= 50) {
            alert("You can select no more than 50 prospects.");
            return;
        }
        setSelectedProspects((prev) => [...prev, prospect]);
        setProspectsList((prev) => prev.filter((p) => p !== prospect));
    }

    const handleRemoveProspect = (prospect) => {
        setSelectedProspects((prev) => prev.filter((p) => p !== prospect));
        setProspectsList((prev) => [...prev, prospect]);
    }

    const handleCreateNewsletter = () => {
        console.log("Create Newsletter clicked", { selectedDigestType, freeSignupText, signUpLinkText, confirmationPopupText, editorPicFile });
    }

    const handleEditNewsletter = () => {
        console.log("Edit clicked");
    }

    const handleSaveNewsletter = () => {
        console.log("Save Newsletter clicked", { selectedDigestType, freeSignupText, signUpLinkText, confirmationPopupText, editorPicFile });
    }

    const handlePublishAd = async () => {
        const digestName = `${selectedDigestType?.name || 'Daily Digest'} ${format(new Date(), "dd-MMM-yy")}`;
        console.log("Publish Ad clicked", { digestName, selectedDigestType, freeSignupText, signUpLinkText, confirmationPopupText, editorPicFile, selectedProspects });
        setOpenPublishAdSuccessModal(true);
        setCreateAdSetDisabled(true);        
                let tabName= null, subtabName=null;
                // let master_category_ids;
                // let master_subcategory_ids;
                let fCats = assignedMasterCategoriesSubCategoriesTree.filter(x => x.isChecked)
                let fAssignedCats = [], MasterCatIds = [], MasterSubCatIds = [];
                for await (const cat of fCats) {
                    console.log('F CAT = ', cat)
                    MasterCatIds.push(cat.cat_id)
                    tabName= cat.cat_id;
                   
                    let fsc = cat.subcats.filter(x => x.isChecked)
                    fsc.map(x => MasterSubCatIds.push(x.sub_cat_id))
                    console.log('F SUB-CAT = ', fsc)
                    if(fsc.length !==0){
                        subtabName= fsc[0].sub_cat_id;
                    }
                   
                }
                const editorPicName = editorPicFile;
                console.log("In internal Gentle Ads::::", tabName,subtabName, author, editorPicName, freeSignupText,signUpLinkText,confirmationPopupText)
                 try {
                        const response = await axios.post(`/api/v3/internalGentleAds`, {
                                tab_name: tabName,
                                subtab_name: subtabName,
                                editors_name: author,
                                editorPicFile: editorPicName,
                                free_Signup_Text: freeSignupText,
                                signUp_Link_Text: signUpLinkText,
                                confirmation_Popup_Text: confirmationPopupText,
                                digest_name:digestName,
                                editor_id: currentUser.userid
                        });
                        console.log('Inserting the Internal Gentle Ads for Inline Article === ', response.data.message);
                        setNewsLetterId(response.data.message.newsletterid)
                    } catch (error) {
                        console.error('Error while Inserting the Internal Gentle Ads for Inline Article API data:', error);
                        
                    }

        // TODO: After successful API call, clear localStorage draft
        // localStorage.removeItem('newsletter_draft_freeSignupText');
        // localStorage.removeItem('newsletter_draft_signUpLinkText');
        // localStorage.removeItem('newsletter_draft_confirmationPopupText');
        // setFreeSignupText("");
        // setSignUpLinkText("");
        // setConfirmationPopupText("");
    }

    const handleSaveSelectedProspects = () => {
        console.log("Save selected prospects clicked", selectedProspects);
    }

    // ***** NON-MEMBER POPUP SECTION HANDLERS *****
    const handleNmCreate = async () => {
        console.log("NM Popup Create clicked", { selectedNmAdType, nmEditorMessage, nmCtaButtonText });
        setnonMemSetIsDisabled(true);
        let tabName= null, subtabName=null;
                // let master_category_ids;
                // let master_subcategory_ids;
                let fCats = assignedMasterCategoriesSubCategoriesTree.filter(x => x.isChecked)
                let fAssignedCats = [], MasterCatIds = [], MasterSubCatIds = [];
                //  console.log('F CAT = ', fCats, selectedNmAdType.id, selectedNmAdType.id === 1)
                if(selectedNmAdType.id === 1){
                    console.log('F CAT = ', fCats)
                    if(fCats.length === 0){
                        alert("Please select the tab and subtab");
                        return;
                    }
                    for await (const cat of fCats) {
                        console.log('F CAT = ', cat)
                        MasterCatIds.push(cat.cat_id)
                        tabName= cat.cat_id;
                    
                        let fsc = cat.subcats.filter(x => x.isChecked)
                        fsc.map(x => MasterSubCatIds.push(x.sub_cat_id))
                        console.log('F SUB-CAT = ', fsc)
                        if(fsc.length !==0){
                            subtabName= fsc[0].sub_cat_id;
                        }
                   
                    }
                }
                console.log("For Non Member Popup box info", tabName,subtabName, selectedNmAdType, nmEditorMessage, nmCtaButtonText, author, currentUser.userid)
                 try {
                        const response = await axios.post(`/api/v3/nonMemberPopup`, {
                                tab_name: tabName,
                                subtab_name: subtabName,
                                selectedNmAdType: selectedNmAdType.name,
                                nmEditorMessage: nmEditorMessage,
                                nmCtaButtonText: nmCtaButtonText,
                                editors_name: author,
                                editor_id: currentUser.userid
                        });
                        console.log('Inserting the Non Member Popup box info for Inline Article === ', response.data.message);
                        setnonMemberPopUpID(response.data.message.non_member_popup_id)
                        if(response.data.sucess){
                            showCustomToast("Popup is sent!")
                        }
                    } catch (error) {
                        console.error('Error while Inserting the Non Member Popup box info for Inline Article API data:', error);
                        
                    }

    }

    const handleNmPreview = () => {
        console.log("NM Popup Preview clicked", { selectedNmAdType, selectedNmTab, nmEditorMessage, nmCtaButtonText });
    }

    const handleNmSave = () => {
        console.log("NM Popup Save clicked", { selectedNmAdType, selectedNmTab, nmEditorMessage, nmCtaButtonText });
    }

    console.log("SearchResultArticles::::", searchResultArticles, editorsSelectedArticlesId);
    return (
        <>
            <Header />
            {loading ? <Box display='flex' justifyContent='center' alignItems='center' height='80vh'><CircularProgress /></Box> :
                <Box mx={3} boxShadow={2} py={1} >
                    <Box display='flex' justifyContent='flex-end' mx={2}>
                        <Button variant='contained' color='inherit' size='small' sx={{ margin: '0 10px' }} onClick={() => history.push('/home')}>Cancel & Go Back</Button>
                        <Button disabled variant='contained' color='error' size='small' sx={{ margin: '0 10px' }} /* onClick={() => history.push('/home')} */>reset</Button>
                        <Button disabled variant='contained' color='secondary' size='small' sx={{ margin: '0 10px' }} /* onClick={() => history.push('/home')} */>Save To My Briefcase</Button>
                        <Button variant='contained' color='success' size='small' sx={{ margin: '0 10px' }} onClick={saveArticle}>Publish</Button>
                    </Box >
                    <Box mx={1} >
                        {/* Article Title */}
                        <Box my={1} p={2} >
                            {/* <Box width="100%" flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Title</Typography>
                            </Box> */}
                            <TextField
                                id="standard-basic"
                                label="News Title"
                                variant="outlined"
                                style={{ width: "100%", marginBottom: 15 }}
                                value={articleTitle}
                                onChange={(e) => setArticleTitle(e.target.value)}
                            />
                            <TextField
                                id="standard-basic"
                                label="Generated Title Slug"
                                variant="standard"
                                style={{ width: "100%" }}
                                value={titleSlug}
                                disabled
                            // onChange={(e) => setTitleSlug(e.target.value)}
                            />
                        </Box>
                        <hr color={colors.indigo[300]} />
                        {/* Article Summary */}
                        <Box my={1} p={2}>
                            {/* <Box flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Summary</Typography>
                            </Box> */}
                            <TextField
                                id="standard-basic"
                                label="News Summary"
                                variant="outlined"
                                style={{ width: "100%" }}
                                multiline
                                rows={3}
                                value={articleSummary}
                                onChange={(e) => setArticleSummary(e.target.value)}
                            />
                        </Box>
                        <hr color={colors.indigo[300]} />
                        {/* Article Photo */}
                        <Box my={1} p={2} display='flex' justifyContent='space-between' alignItems='center'>
                            <Box width='49%'>
                                <Box position="relative" display='flex' justifyContent='flex-start' alignItems='center'>
                                    {/* <IconButton sx={{ position: "absolute", top: -10, right: 90, visibility: articlePictureFile ? "visible" : "hidden" }} onClick={() => { setArticlePhoto(null); setArticlePictureFile(null) }} size="small">
                                        <ClearIcon color="error" size="small" />
                                    </IconButton>
                                    <img width="80%" height='50%' src={articlePictureFile} /> */}
                                    {imageList.length > 0 &&
                                        <>
                                            <Box display='flex' flexDirection='column' width='100%' overflow="none" >
                                                <Box>
                                                    <SimpleImageSlider
                                                        width={350}
                                                        height={200}
                                                        images={imageList}
                                                        showBullets={true}
                                                    // showNavs={true}
                                                    />
                                                </Box>
                                                <Box>
                                                    {imageList.map(img => <Chip label={img.name || img.url} size='small' onDelete={(e) => { setImageList(imageList.filter(fimg => fimg.url !== img.url)) }} />)}
                                                </Box>
                                            </Box>
                                        </>
                                    }
                                </Box>
                                <Box display='flex' justifyContent='flex-start' alignItems='center'>
                                    <Button variant="text" component="label" size='small' endIcon={<PhotoCamera fontSize='small' name='upload Pic' />}>
                                        Upload Image
                                        <input hidden multiple accept="image/*" type="file" name="picture_path"
                                            onChange={(e) => uploadProfilePicture(e)}
                                        />
                                    </Button>
                                </Box>
                            </Box>
                            <Box width='49%'>
                                <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} >
                                    <TextField
                                        required
                                        select
                                        id="store-image"
                                        label="Store Image"
                                        variant="standard"
                                        size="small"
                                        value={imageType}
                                        onChange={(e) => setImageType(e.target.value)}
                                        style={{ textAlign: 'left', width: '150px' }}
                                        inputProps={{ style: { height: "200px" } }}
                                    >
                                        <MenuItem value={'company'}>Company Image</MenuItem>
                                        <MenuItem value={'article'}>Article Image</MenuItem>
                                    </TextField>
                                    <Box mt={2} mx={1}>{!imageType && <AssistantPhoto color='error' />}</Box>
                                </Box>
                                <Box my={2}  >
                                    <TextField
                                        required
                                        id="standard-basic"
                                        label="Alt Tag"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        value={imageAltTag}
                                        // disabled={!articlePictureFile}
                                        onChange={(e) => setImageAltTag(e.target.value)}
                                    />
                                </Box>
                                <Box >
                                    <TextField
                                        required
                                        id="standard-basic"
                                        label="Image Caption"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        value={imageCaption}
                                        // disabled={!articlePictureFile}
                                        onChange={(e) => setImageCaption(e.target.value)}
                                    />
                                </Box>
                                <Box my={2}>
                                    <TextField
                                        id="standard-basic"
                                        label="Image Credit (optional)"
                                        variant="standard"
                                        style={{ width: "100%" }}
                                        value={imageCredit}
                                        // disabled={!articlePictureFile}
                                        onChange={(e) => { setImageCredit(e.target.value) }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        <hr color={colors.indigo[300]} />

                        {/* <InternalLinkSearchComp /> */}

                        {/* Article Description */}
                        <Box my={1} p={2} minHeight={450}>
                            {/* <Box width="100%" flexDirection={"column"} justifyContent="flex-start" mb={1}>
                                <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}> Description</Typography>
                            </Box> */}
                            {/* <Editor
                                editorState={articleDescriptionState}
                                wrapperClassName="wrapper-class"
                                editorClassName="editor-class"
                                toolbarClassName="toolbar-class"
                                onEditorStateChange={handleEditorArticleDescription}
                                toolbar={{
                                    link: { inDropdown: true },
                                    history: { inDropdown: true },
                                }}
                                placeholder={('News Description...')}
                                editorStyle={{ height: "350px" }}
                            /> */}
                            <ReactQuill
                                ref={quillRef}
                                value={articleDescription}
                                onChange={handleChange}
                                modules={modules}
                                formats={formats}
                                theme="snow"
                                placeholder="Start writing here..."
                                style={{ height: "400px" }}
                            />
                        </Box>
                        {/* <hr color={colors.indigo[300]} /> */}
                        {/* <Box my={1} p={2}>
                            <FinancialTableComp />
                        </Box> */}
                        <hr color={colors.indigo[300]} />
                        {/* Location--People-Industry */}
                        <Box display="flex" flexDirection="row" justifyContent="space-between" my={2} p={2}>
                            <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                <Box>
                                    <TextField
                                        type="text"
                                        variant='standard'
                                        className="search"
                                        placeholder="Enter Location Name..."
                                        label='Location'
                                        fullWidth
                                        // style={{ width: "250px" }}
                                        InputLabelProps={{ shrink: true }}
                                        // onChange={(e) => {
                                        //     if (e.target.value) {
                                        //         setParentCompany(e.target.value)
                                        //         optimizedFn(e.target.value)
                                        //     } else
                                        //         setCompanySuggestions([])
                                        // }}
                                        // onFocus={() => SetSuggDropDownState(true)}
                                        // onBlur={() => setTimeout(() => {
                                        //     SetSuggDropDownState(false)
                                        // }, 100)}
                                        // defaultValue={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        value={location}
                                        InputProps={{
                                            endAdornment: (
                                                <>
                                                    {locationSuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                    <IconButton onClick={() => { setLocation(""); setLocationSuggestions([]) }} size="small">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    <IconButton onClick={() => handleLocationList({ code: "", name: location })} size="small">
                                                        <AddBoxIcon />
                                                    </IconButton>
                                                </>
                                            )
                                        }}
                                    />
                                    {locationSuggestion.length && locationSuggDropDownState
                                        ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: '100%', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                            {locationSuggestion.map((option, idx) =>
                                                <MenuItem
                                                    sx={{ fontSize: 13 }}
                                                    key={option.code || idx}
                                                    value={option.name}
                                                    onClick={() => {
                                                        handleLocationList(option);
                                                        setTimeout(() => {
                                                            setLocationSuggDropDownState(false);
                                                        }, 100);
                                                    }}
                                                >
                                                    {option.name}
                                                </MenuItem>
                                            )}
                                        </Box>
                                        : null}
                                </Box>
                                <Box>
                                    {locationList.length ? locationList.map((loc, i) =>
                                        loc && <Chip key={i} label={loc.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteLocation(loc)} />
                                    ) : null}
                                </Box>
                            </Box>

                            {/* ASSOCIATED PEOPLE */}
                            <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                <Box>
                                    <TextField
                                        type="text"
                                        variant='standard'
                                        className="search"
                                        placeholder="Enter People Name..."
                                        label='People Name'
                                        fullWidth
                                        // style={{ width: "250px" }}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                setPeopleNames(e.target.value)
                                                optimizedPeopleFn(e.target.value)
                                            } else
                                                setPeopleNames("")
                                            setPeopleSuggestions([])
                                        }}
                                        onFocus={() => setPeopleSuggDropDownState(true)}
                                        // onBlur={() => setTimeout(() => {
                                        //     setPeopleSuggDropDownState(false)
                                        // }, 100)}
                                        // defaultValue={peopleNames}
                                        value={peopleNames}
                                        InputProps={{
                                            endAdornment: (
                                                <>
                                                    {peopleSuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                    <IconButton onClick={() => { setPeopleNames(""); setPeopleSuggestions([]) }} size="small">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    {/* <IconButton onClick={() => handlePeopleNamesList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                </>
                                            )
                                        }}
                                    />
                                    {peopleSuggestion.length && peopleSuggDropDownState
                                        ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                            {peopleSuggestion.map((option, idx) =>
                                                <MenuItem
                                                    sx={{ fontSize: 13 }}
                                                    key={option.insider_cik || idx}
                                                    value={option.name}
                                                    onClick={() => {
                                                        setTimeout(() => {
                                                            setPeopleSuggDropDownState(false);
                                                        }, 250);
                                                        handlePeopleNamesList(option);
                                                    }}
                                                >
                                                    {option.name}&nbsp;{option.relatedto && <span style={{ color: colors.blue[400], fontWeight: 500 }}>({option.relatedto})</span>}
                                                </MenuItem>
                                            )}
                                        </Box>
                                        : null}
                                </Box>
                                <Box>
                                    {peopleNamesList?.length
                                        ? peopleNamesList.map((ppl, i) =>
                                            ppl && <Chip key={ppl.id} label={ppl.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeletePeople(ppl)} />
                                        ) : null}
                                </Box>
                            </Box>

                            {/* ASSOCIATED COMPANIES SECTION */}
                            <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                <Box>
                                    <TextField
                                        type="text"
                                        variant='standard'
                                        className="search"
                                        placeholder="Enter Ticker Company Name..."
                                        label='Associated Companies'
                                        fullWidth
                                        // style={{ width: "250px" }}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                setCompany(e.target.value)
                                                optimizedCompanyFn(e.target.value)
                                            } else
                                                setCompany("")
                                            setCompanySuggestions([])
                                        }}
                                        onFocus={() => setCompanySuggDropDownState(true)}
                                        // onBlur={() => setTimeout(() => {
                                        //     setCompanySuggDropDownState(false)
                                        // }, 100)}
                                        // defaultValue={company}
                                        value={company}
                                        InputProps={{
                                            endAdornment: (
                                                <>
                                                    {companySuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                    <IconButton onClick={() => { setCompany(""); setCompanySuggestions([]) }} size="small">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    {/* <IconButton onClick={() => handlecompanyList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                </>
                                            )
                                        }}
                                    />
                                    {companySuggestion.length && companySuggDropDownState
                                        ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                            {companySuggestion.map((option, idx) =>
                                                <MenuItem
                                                    sx={{ fontSize: 13 }}
                                                    key={option.cik || idx}
                                                    value={option.name}
                                                    onClick={() => {
                                                        setTimeout(() => {
                                                            setCompanySuggDropDownState(false);
                                                        }, 250);
                                                        handleCompanyList(option);
                                                    }}
                                                >
                                                    {option.name || option}&nbsp;
                                                    {option.ticker && <span style={{ color: colors.blue[400], fontWeight: 500 }}>[{option.ticker}]</span>}
                                                </MenuItem>
                                            )}
                                        </Box>
                                        : null}
                                </Box>
                                <Box>
                                    {companyList?.length ? companyList.map((comp, i) =>
                                        <Chip key={comp.name || comp} label={comp.name || comp} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteCompany(comp)} />
                                    ) : null}
                                </Box>
                            </Box>

                            {/* ASSOCIATED SIC OR INDUSTRIES */}
                            <Box display="flex" flexDirection="column" position="relative" width='250px'>
                                <Box>
                                    <TextField
                                        type="text"
                                        variant='standard'
                                        className="search"
                                        placeholder="Enter Industry Name..."
                                        label='SIC | Industry'
                                        fullWidth
                                        // style={{ width: "250px" }}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                setIndustry(e.target.value)
                                                optimizedIndustryeFn(e.target.value)
                                            } else
                                                setIndustry("")
                                            setIndustrySuggestions([])
                                        }}
                                        onFocus={() => setIndustrySuggDropDownState(true)}
                                        // onBlur={() => setTimeout(() => {
                                        //     setIndustrySuggDropDownState(false)
                                        // }, 100)}
                                        // defaultValue={industry}
                                        value={industry}
                                        InputProps={{
                                            endAdornment: (
                                                <>
                                                    {industrySuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                    <IconButton onClick={() => { setIndustry(""); setIndustrySuggestions([]) }} size="small">
                                                        <ClearIcon />
                                                    </IconButton>
                                                    {/* <IconButton onClick={() => handleIndustryList()} size="small">
                                                            <AddBoxIcon />
                                                        </IconButton> */}
                                                </>
                                            )
                                        }}
                                    />
                                    {industrySuggestion.length && industrySuggDropDownState
                                        ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                            {industrySuggestion.map((option, idx) =>
                                                <MenuItem
                                                    sx={{ fontSize: 13 }}
                                                    key={option.code || idx}
                                                    value={option.sic_name}
                                                    onClick={() => {
                                                        handleIndustryList(option);
                                                        setTimeout(() => {
                                                            setIndustrySuggDropDownState(false);
                                                        }, 100);
                                                    }}
                                                >
                                                    {option.sic_name}&nbsp;<span style={{ color: colors.blue[400], fontWeight: 500 }}>[{option.sic_grp_name}]</span>
                                                </MenuItem>
                                            )}
                                        </Box>
                                        : null}
                                </Box>
                                <Box>
                                    {industryList?.length ? industryList.map((ind, i) =>
                                        <Chip key={ind.code} label={ind.name} size='small' style={{ margin: '3px' }} onDelete={() => handleDeleteIndustry(ind)} />
                                    ) : null}
                                </Box>
                            </Box>
                        </Box>
                        <hr color={colors.indigo[300]} />
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignContent="center" alignItems="center">
                            {/* Manage Categories */}
                            <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <Button variant='outlined' size='large' onClick={() => setOpenCategoryModal(p => !p)} startIcon={<ManageSearchSharp fontSize='large' color='secondary' />}>Manage Categories</Button>
                            </Box>
                            {/* Manage Categories */}
                            {/* <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <Button variant='outlined' size='large' onClick={() => setOpenIndicatorsModal(p => !p)} startIcon={<ManageSearchSharp fontSize='large' color='secondary' />}>Manage Macro Indicators</Button>
                            </Box> */}
                            <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <TextField
                                    select
                                    id="weight"
                                    label="News Weight"
                                    variant="standard"
                                    size="small"
                                    value={selectedWeight}
                                    onChange={(e) => setSelectedWeight(e.target.value)}
                                    style={{ margin: 12, width: '90%', textAlign: 'left', width: '150px' }}
                                    inputProps={{ style: { height: "200px" } }}
                                >
                                    <MenuItem value='1' title='True breaking news from AP, no matter what category'>1</MenuItem>
                                    <MenuItem value='2' title='Press releases for top 100 companies; top 5 macro news in minutes we generate; top 100 micro news in minutes we generate'>2</MenuItem>
                                    <MenuItem value='3' title='Default AP news articles'>3</MenuItem>
                                    <MenuItem value='4' title='Press releases for 3900-4000 companies; top 6-25 macro news in minutes we generate; 101-500 micro news in minutes we generate'>4</MenuItem>
                                    <MenuItem value='5' title='Hyperlocal articles; bottom 3900 press releases; bottom 4900 micro news in minutes we generate'>5</MenuItem>
                                </TextField>
                            </Box>
                            <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <TextField
                                    select
                                    id="priority"
                                    label="News Priority"
                                    variant="standard"
                                    size="small"
                                    value={selectedPriority}
                                    onChange={(e) => setSelectedPriority(e.target.value)}
                                    style={{ margin: 12, textAlign: 'left', width: '150px' }}
                                    inputProps={{ style: { height: "200px" } }}
                                >
                                    {priorityList.length > 0 && priorityList.map((priority, idx) => <MenuItem key={idx} id={idx} value={priority}>{priority}</MenuItem>)}
                                </TextField>
                            </Box>
                            <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <TextField
                                    id="standard-basic"
                                    label="Article Version"
                                    variant="standard"
                                    style={{ width: "150px" }}
                                    value={articleVersion}
                                    onChange={(e) => setArticleVersion(e.target.value)}
                                />
                            </Box>
                            <Box width='25%' my={1} p={2} display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                                <FormControlLabel
                                    label="Featured News"
                                    control={
                                        <Checkbox
                                            size='small'
                                            checked={isFeatured}
                                            onChange={() => setIsFeatured(!isFeatured)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />}
                                />
                            </Box>
                        </Box>
                        <hr color={colors.indigo[300]} />
                        {/* Macro-Indicator Drop Down */}
                        <Box display="flex" flexDirection="row" justifyContent="space-between" alignContent="center" alignItems="center" my={2} p={2}>
                            <Box width="35%">
                                <FormControl fullWidth>
                                    <InputLabel id="article-sub-category-multiple-checkbox-label">Macro Indicator Category</InputLabel>
                                    <Select
                                        fullWidth
                                        variant='outlined'
                                        label="Select Macro Indicator Category"
                                        InputLabelProps={{ shrink: true }}
                                        value={selectedMacroIndicator ?? null}
                                        MenuProps={MenuProps}
                                        input={<OutlinedInput label="Article Sub Category " />}
                                        onChange={(e) => setSelectedMacroIndicator(e.target.value)}
                                    >
                                        {assignedMasterMacroIndicatorTree.length > 0 &&
                                            assignedMasterMacroIndicatorTree.map((category, idx) =>
                                                <MenuItem key={idx} id={category.category_id} value={category} sx={{ fontSize: 14, padding: 1 }}>
                                                    {category.category_name}
                                                </MenuItem>
                                            )}
                                    </Select>
                                </FormControl>
                            </Box>

                            {/* Macro-Indicator Sub Drop Down */}
                            <Box width="45%">
                                <FormControl fullWidth>
                                    <InputLabel id="article-sub-category-multiple-checkbox-label">Macro Indicators</InputLabel>
                                    <Select
                                        multiple
                                        fullWidth
                                        disabled={!selectedMacroIndicator}
                                        label="Select Macro Indicator Category"
                                        value={selectedMacroSubIndicatorList ?? null}
                                        renderValue={selectedIndicators => selectedIndicators.map(ind => ind.indicator_name).join(", ")}
                                        onChange={(e) => setSelectedMacroSubIndicatorList(e.target.value)}
                                        input={<OutlinedInput label="Article Sub Category " />}
                                        MenuProps={MenuProps}>
                                        {selectedMacroIndicator && assignedMasterMacroIndicatorTree
                                            .filter(f => f.category_id === selectedMacroIndicator.category_id)[0].indicators
                                            .map((ind) =>
                                                <MenuItem key={ind.indicator_id} value={ind}
                                                    onChange={(e) => handleMacroIndicatorChange(e, ind, selectedMacroIndicator)}
                                                    sx={{ fontSize: 14, padding: 0 }}>
                                                    <Checkbox checked={ind.isChecked} value={ind.indicator_name} />{ind.indicator_name}
                                                </MenuItem>
                                            )}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width="5%">
                                <Button size='small' variant='outlined' onClick={handleAssignMacroIndicator} >Assign</Button>
                            </Box>
                        </Box>
                        <Box width="100%" display='flex' flexDirection='row' justifyContent='flex-start' alignItems='flex-start' flexWrap='wrap' m={1}>
                            {selectedMacroIndicatorList.length
                                ? selectedMacroIndicatorList.map((cat) => {
                                    if (cat.isChecked) {
                                        console.log('CHECKED INDICATOR === ', cat)
                                        let ind = cat.indicators.filter(ind => ind.isChecked);
                                        return <Chip label={`${cat.category_name} > ${ind.map(o => o.indicator_name)}`} sx={{ m: 1 }} size='small' />
                                    }
                                })
                                : null}
                        </Box>
                        <hr color={colors.indigo[300]} />
                        <Box display='flex' justifyContent='space-between' alignContent='center' alignItems='center'>
                            <Box display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center" alignItems="center">
                                <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Published Date:</Typography>
                                &emsp;
                                <Typography variant="body1" color={colors.blueGrey[800]} sx={{ textDecorationLine: 'none', textAlign: 'right' }}>{new Date(startDate).toString()}</Typography>
                            </Box>
                            <Box display="flex" flexDirection="row" justifyContent="flex-start" alignContent="center" alignItems="center">
                                <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Author Name:</Typography>
                                &emsp;
                                {/* <Typography variant="body1" color={colors.blueGrey[800]} sx={{ textDecorationLine: 'none', textAlign: 'right' }}>{author}</Typography> */}
                                <TextField
                                    id="standard-basic"
                                    label=""
                                    variant="outlined"
                                    size='small'
                                    style={{ width: "250px" }}
                                    value={author}
                                    disabled
                                    // onChange={(e) => setAuthor(e.target.value)}
                                />
                            </Box>
                            <Box mx={1}>
                                <Typography variant='caption' sx={{ fontWeight: 700, color: colors.deepOrange[700], fontSize: 16, textAlign: 'left', lineHeight: 2.3 }}>Is Article Indexable:&nbsp;
                                    <Checkbox
                                        size='medium'
                                        checked={isArticleIndexable}
                                        onChange={() => setIsArticleIndexable(!isArticleIndexable)}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Typography>
                            </Box>
                        </Box>
                        <hr color={colors.indigo[300]} />
                        
                        {/* *************************************** */}
                        {/* SEARCH & ATTACH RELATED ARTICLE SECTION  */}
                        {/* *************************************** */}

                        <Box display='flex' flexDirection='column'>
                            <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Attach Links to Original Article:</Typography>
                            <Typography variant='h5' fontSize={13} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left', marginLeft: 2 }}>Attached links:</Typography>
                            <Box display='flex' flexDirection={'column'} justifyContent='space-between' alignContent='flex-start' alignItems='flex-start' flexWrap='wrap' mt={1}>
                                {editorsSelectedArticles.length ? editorsSelectedArticles.map((art) => (

                                    <Chip label={art.title} sx={{ mb: 1 }} size='small' color='primary' onDelete={() => handleRemoveRelatedArticle(art.article_id)} />
                                )) : null}
                            </Box>
                            <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left' }}>Search Related Article:</Typography>
                            <Box display='flex' justifyContent='space-between' alignContent='center' alignItems='center' flexWrap='wrap' mt={1}>
                                <Box mt={1}>
                                    <TextField
                                        id="search_author"
                                        label="Search By Author"
                                        variant="outlined"
                                        size="small"
                                        value={searchByAuthor}
                                        onChange={(e) => setSearchByAuthor(e.target.value)}
                                        style={{ textAlign: 'left', width: '200px' }}
                                    />

                                </Box>
                                <Box mt={1}>
                                    <TextField
                                        select
                                        id="search_author"
                                        variant="outlined"
                                        label="Search By Category"
                                        size="small"
                                        value={searchByCategoryId}
                                        onChange={(e) => setSearchByCategoryId(e.target.value)}
                                        style={{ textAlign: 'left', width: '200px' }}
                                        inputProps={{ style: { height: "200px" } }}
                                    >
                                        {masterCategoriesSubCategoriesTree.map((cat, i) => (
                                            <MenuItem key={i} value={cat.cat_id}>{cat.cat_name}</MenuItem>
                                        ))}

                                    </TextField>
                                </Box>
                                <Box mt={1}>
                                    <TextField
                                        select
                                        disabled={searchByCategoryId ? false : true}
                                        id="search_author"
                                        variant="outlined"
                                        label="Search By Sub Category"
                                        size="small"
                                        value={searchBySubCategoryId}
                                        onChange={(e) => setSearchBySubCategoryId(e.target.value)}
                                        style={{ textAlign: 'left', width: '200px' }}
                                        inputProps={{ style: { height: "200px" } }}
                                    >
                                        {masterCategoriesSubCategoriesTree.find(cat => cat.cat_id === searchByCategoryId)?.subcats?.map((subcat, i) => (
                                            <MenuItem key={i} value={subcat.sub_cat_id}>{subcat.sub_cat_name}</MenuItem>
                                        ))}

                                    </TextField>
                                </Box>
                                <Box mt={1}>
                                    <TextField
                                        name='company'
                                        title='company Name'
                                        variant='outlined'
                                        label="Search By Company"
                                        size='small'
                                        placeholder='Enter company Ticker/Name'
                                        style={{ width: "250px" }}
                                        value={searchCompany}
                                        onChange={(event) => setSearchCompany(event.target.value)}
                                    />
                                    {/* <TextField
                                        type="text"
                                        variant='outlined'
                                        size='small'
                                        className="search"
                                        placeholder="Enter company Ticker/Name"
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: "250px" }}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                setSearchCompany(e.target.value)
                                                optimizedCompanyFn(e.target.value)
                                            } else
                                                setSearchCompany("")
                                            setCompanySuggestions([])
                                        }}
                                        onFocus={() => setCompanySuggDropDownState(true)}
                                        value={searchCompany}
                                        InputProps={{
                                            endAdornment: (
                                                <>
                                                    {companySuggLoading ? <HourglassTopRounded size="small" color="info" /> : null}
                                                    <IconButton onClick={() => { setSearchCompany(""); setCompanySuggestions([]) }} size="small">
                                                        <ClearIcon />
                                                    </IconButton>
                                                </>
                                            )
                                        }}
                                    />
                                    {companySuggestion.length && companySuggDropDownState
                                        ? <Box style={{ maxHeight: '180px', backgroundColor: 'rgb(243 246 249 / 90%)', position: 'absolute', width: 'auto', zIndex: 10, overflow: "hidden", overflowY: "scroll", boxShadow: '#C5C5C5 10px 10px 30px 0px', paddingBottom: '5px' }}>
                                            {companySuggestion.map((option, idx) =>
                                                <MenuItem
                                                    sx={{ fontSize: 13 }}
                                                    key={option.cik || idx}
                                                    value={option.name}
                                                    onClick={() => {
                                                        setTimeout(() => {
                                                            setCompanySuggDropDownState(false);
                                                        }, 250);
                                                        handleCompanyList(option);
                                                    }}
                                                >
                                                    {option.name || option}&nbsp;
                                                    {option.ticker && <span style={{ color: colors.blue[400], fontWeight: 500 }}>[{option.ticker}]</span>}
                                                </MenuItem>
                                            )}
                                        </Box>
                                        : null} */}
                                </Box>
                                <Box mt={1}>
                                    <TextField
                                        name='keywords'
                                        title='keywords'
                                        variant='outlined'
                                        label="Search By Keywords"
                                        size='small'
                                        placeholder='Enter Keywords'
                                        style={{ width: "200px" }}
                                        value={searchKeywords}
                                        onChange={(event) => setSearchKeywords(event.target.value)}
                                    />
                                </Box>
                                <Box mt={1}>
                                    <ReactDatePicker id="ReactDatePicker"
                                        monthsShown={2}
                                        className='ReactDatePicker'
                                        dateFormat="MMM dd, yyyy"
                                        selectsRange={true}
                                        startDate={dateRange[0]}
                                        endDate={dateRange[1]}
                                        maxDate={new Date()}
                                        onChange={date_range => handleDateRange(date_range)}
                                    />
                                </Box>
                                <Box mt={1}>
                                    <Button variant='outlined' size='small' onClick={handleSearchArticle}>Search</Button>
                                </Box>
                            </Box>
                            {searchResultArticles?.length && searchResultArticles.length > 0 ?
                                <Box display={'flex'} flexDirection={'column'}>
                                    <div style={{ padding: '20px' }}>
                                        <h3>Select Articles</h3>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {searchResultArticles?.map((article) => (
                                                <label
                                                    key={article.article_id}
                                                    style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', width: 'max-content' }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={editorsSelectedArticlesId.includes(article.article_id)}
                                                        onChange={() => handleArticleSelect(article.article_id)}
                                                        style={{ marginRight: '10px', height: '20px', width: '20px' }}
                                                    />
                                                    <a href={`https://candorium.com/news/${article?.article_id}/${article.title_slug}`} target='_blank'>{article.title}</a>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                    <Box display='flex' justifyContent='center' p={2}>
                                        <Button variant='contained' color='info' size='small' sx={{ margin: '0 10px' }} onClick={handleSelectedArticles}>Attach Links to Article</Button>
                                    </Box>
                                </Box>
                                : null}
                        </Box>

                        {/* *************************************** */}
                        {/* CREATE AD AND NEWSLETTER SECTION         */}
                        {/* *************************************** */}
                        <hr color={colors.indigo[300]} />
                        <Box display='flex' flexDirection='column' my={1} p={2}>
                            <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left', mb: 2 }}>Create Ad and Newsletter:</Typography>

                            {/* Editor pic upload */}
                            <Box display='flex' flexDirection='row' alignItems='center' mb={2}>
                                <Box display='flex' flexDirection='column' alignItems='center' mr={2}>
                                    <Box width={150} height={100} border={`1px dashed ${colors.blueGrey[300]}`} display='flex' justifyContent='center' alignItems='center' overflow='hidden'>
                                        {editorPicFile
                                            ? <img src={editorPicFile} alt='editor' style={{ maxWidth: '100%', maxHeight: '100%' }} />
                                            : <Typography variant='caption' color={colors.blueGrey[400]}>Upload Editor's pic</Typography>}
                                    </Box>
                                    {/* <Button variant="text" component="label" size='small'>
                                        <input hidden accept="image/*" type="file" onChange={handleUploadEditorPic} />
                                    </Button> */}
                                </Box>
                            </Box>

                            {/* Two column layout: Create Daily Digest | Send to */}
                            <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start'>

                                {/* LEFT: Create Daily Digest */}
                                <Box width='48%' display='flex' flexDirection='column'>
                                    {/* Label row - OUTSIDE border */}
                                    <Box display='flex' flexDirection='row' alignItems='center' mb={1}>
                                        <Typography variant='h5' fontSize={14} fontWeight={700} color={colors.blueGrey[700]} mr={2}>Create Daily Digest</Typography>
                                        <TextField
                                            select
                                            variant='outlined'
                                            size='small'
                                            value={selectedDigestType?.id || ''}
                                            onChange={(e) => {
                                                const selected = digestTypesList.find(d => d.id === e.target.value)
                                                setSelectedDigestType(selected)
                                            }}
                                            sx={{ backgroundColor: colors.pink[100], minWidth: 180 }}
                                        >
                                            {digestTypesList.map((type) => (
                                                <MenuItem key={type.id} value={type.id}>
                                                    {type.name}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <Typography variant='body1' fontWeight={600} color={colors.blueGrey[700]} ml={2}>
                                            {format(new Date(), "dd-MMM-yy")}
                                        </Typography>
                                    </Box>

                                    {/* Bordered content box */}
                                    <Box border={`1px solid ${colors.blueGrey[300]}`} borderRadius={2} p={2}>
                                        <Box display='flex' flexDirection='row' alignItems='flex-start' mb={2}>
                                            <Typography variant='body2' color={colors.blueGrey[700]} width='35%' textAlign='left' pt={1} >Enter text for the free sign up to the <b>Internal ad</b></Typography>
                                            <TextField
                                                variant='outlined'
                                                multiline
                                                rows={4}
                                                fullWidth
                                                placeholder='Enter Text for daily digest email... lively conversational engagement with audience that includes <links to the article>'
                                                value={freeSignupText}
                                                onChange={(e) => setFreeSignupText(e.target.value)}
                                            />
                                        </Box>

                                        <Box display='flex' flexDirection='row' alignItems='center' mb={2}>
                                            <Typography variant='body2' color={colors.blueGrey[700]} width='35%' textAlign='left'>Enter text for the <b>sign up link</b></Typography>
                                            <TextField
                                                variant='outlined'
                                                size='small'
                                                fullWidth
                                                placeholder='Enter Text'
                                                value={signUpLinkText}
                                                onChange={(e) => setSignUpLinkText(e.target.value)}
                                            />
                                        </Box>

                                        <Box display='flex' flexDirection='row' alignItems='center' mb={2}>
                                            <Typography variant='body2' color={colors.blueGrey[700]} width='35%' textAlign='left'>Enter text for <b>confirmation pop up</b> after sign up</Typography>
                                            <TextField
                                                variant='outlined'
                                                size='small'
                                                fullWidth
                                                placeholder='Enter Text'
                                                value={confirmationPopupText}
                                                onChange={(e) => setConfirmationPopupText(e.target.value)}
                                            />
                                        </Box>

                                        <Box display='flex' flexDirection='row' justifyContent='flex-start'>
                                            <Button variant='contained' color='primary' size='small' disabled={createAdDisabled} onClick={handlePublishAd}>Publish Ad</Button>
                                        </Box>
                                    </Box>
                                </Box>

                                {/* RIGHT: Send to */}
                                <Box width='48%' display='flex' flexDirection='column'>
                                    {/* Label row - OUTSIDE border */}
                                    <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' mb={1}>
                                        <Typography variant='h5' fontSize={14} fontWeight={700} color={colors.blueGrey[700]}>Send to:</Typography>
                                        <Button variant='contained' size='small' onClick={handleSaveSelectedProspects}>Save selected prospects</Button>
                                    </Box>

                                    {/* Bordered content box */}
                                    <Box border={`1px solid ${colors.blueGrey[300]}`} borderRadius={2} p={2}>
                                        <Typography variant='body2' color={colors.blueGrey[700]} textAlign='left' mb={1} fontWeight='bold'>Select the prospects</Typography>

                                        <Box display='flex' flexDirection='row' alignItems='center' justifyContent='space-between'>
                                            {/* Available prospects */}
                                            <Box width='45%' height={180} border={`1px solid ${colors.blueGrey[200]}`} overflow='auto' p={1}>
                                                {prospectsList.length
                                                    ? prospectsList.map((prospect, idx) => (
                                                        <MenuItem key={idx} sx={{ fontSize: 13 }} onClick={() => handleAddProspect(prospect)}>{prospect}</MenuItem>
                                                    ))
                                                    : <Typography variant='caption' color={colors.blueGrey[400]}>List box shows list of prospects based on tab [prospect list is stored in DB from Salesbrandy]</Typography>}
                                            </Box>

                                            <Box width='10%' display='flex' justifyContent='center'>
                                                <Typography variant='h4' color={colors.blueGrey[500]}>&rarr;</Typography>
                                            </Box>

                                            {/* Selected prospects */}
                                            <Box width='45%' height={180} border={`1px solid ${colors.blueGrey[200]}`} overflow='auto' p={1}>
                                                {selectedProspects.length
                                                    ? selectedProspects.map((prospect, idx) => (
                                                        <MenuItem key={idx} sx={{ fontSize: 13 }} onClick={() => handleRemoveProspect(prospect)}>{prospect}</MenuItem>
                                                    ))
                                                    : <Typography variant='caption' color={colors.blueGrey[400]}>selected prospects (no more than 50)</Typography>}
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>

                        {/* *************************************** */}
                        {/* NON-MEMBER POPUP SECTION                */}
                        {/* *************************************** */}
                        <hr color={colors.indigo[300]} />
                        <Box display='flex' flexDirection='column' my={1} p={2}>
                            <Typography variant='h3' fontSize={15} fontWeight={700} color={colors.blueGrey[600]} sx={{ textDecorationLine: 'underline', textAlign: 'left', mb: 1 }}>Non-Member Popup:</Typography>

                            <Typography variant='body1' fontWeight={700} color={colors.blueGrey[700]} textAlign='left'>Non Member Sign up Popup</Typography>
                            <Typography variant='body2' color={colors.blueGrey[600]} textAlign='left' mb={2}>This popup is sent to non members when they click an ad</Typography>

                            {/* Select Ad Type | Select Tab */}
                            <Box display='flex' flexDirection='row' justifyContent='flex-start' alignItems='flex-start' gap={4} mb={2}>
                                <Box display='flex' flexDirection='column' alignItems='flex-start'>
                                    <Typography variant='body2' color={colors.blueGrey[700]} fontWeight='bold' mb={0.5}>Select Ad Type</Typography>
                                    <TextField
                                        select
                                        variant='outlined'
                                        size='small'
                                        value={selectedNmAdType?.id || ''}
                                        onChange={(e) => {
                                            const selected = nmAdTypesList.find(d => d.id === e.target.value)
                                            setSelectedNmAdType(selected)
                                        }}
                                        sx={{ minWidth: 220, backgroundColor: '#fff' }}
                                    >
                                        {nmAdTypesList.map((type) => (
                                            <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                                        ))}
                                    </TextField>
                                </Box>
                                {/*<Box display='flex' flexDirection='column' alignItems='flex-start'>
                                    <Typography variant='body2' color={colors.blueGrey[700]} fontWeight='bold' mb={0.5}>Select Tab</Typography>
                                    <TextField
                                        select
                                        variant='outlined'
                                        size='small'
                                        value={selectedNmTab?.id || ''}
                                        onChange={(e) => {
                                            const selected = nmTabsList.find(d => d.id === e.target.value)
                                            setSelectedNmTab(selected)
                                        }}
                                        sx={{ minWidth: 220, backgroundColor: '#fff' }}
                                    >
                                        {nmTabsList.map((tab) => (
                                            <MenuItem key={tab.id} value={tab.id}>{tab.name}</MenuItem>
                                        ))}
                                    </TextField>
                                </Box>*/}
                            </Box>

                            {/* Editor Message */}
                            <Box display='flex' flexDirection='column' alignItems='flex-start' mb={2}>
                                <Typography variant='body2' color={colors.blueGrey[700]} fontWeight='bold' mb={0.5}>Editor Message</Typography>
                                <TextField
                                    variant='outlined'
                                    multiline
                                    rows={4}
                                    fullWidth
                                    value={nmEditorMessage}
                                    onChange={(e) => setNmEditorMessage(e.target.value)}
                                />
                            </Box>

                            {/* CTA Button Text + live preview */}
                            <Box display='flex' flexDirection='column' alignItems='flex-start' mb={3}>
                                <Typography variant='body2' color={colors.blueGrey[700]} fontWeight='bold' mb={0.5}>CTA Button Text</Typography>
                                <Box display='flex' flexDirection='row' alignItems='center' gap={2}>
                                    <TextField
                                        variant='outlined'
                                        size='small'
                                        value={nmCtaButtonText}
                                        onChange={(e) => setNmCtaButtonText(e.target.value)}
                                        sx={{ minWidth: 220 }}
                                    />
                                    <Button
                                        variant='contained'
                                        size='small'
                                        sx={{ backgroundColor: colors.indigo[900], textTransform: 'none', '&:hover': { backgroundColor: colors.indigo[800] } }}
                                    >
                                        {nmCtaButtonText || 'Get the report'}
                                    </Button>
                                </Box>
                            </Box>

                            {/* Action buttons */}
                            <Box display='flex' flexDirection='row' justifyContent='center' gap={3}>
                                <Button variant='contained' color='primary' disabled={nonMemIsDisabled} onClick={handleNmCreate} sx={{ minWidth: 120 }}>Create</Button>
                            </Box>
                        </Box>
                    </Box>
                    <hr color={colors.indigo[300]} />
                    <Box display='flex' justifyContent='flex-end' p={2} my={3} bgcolor={colors.blueGrey[50]}>
                        <Button variant='contained' color='inherit' size='small' sx={{ margin: '0 10px' }} onClick={() => history.push('/home')}>Cancel & Go Back</Button>
                        <Button disabled variant='contained' color='error' size='small' sx={{ margin: '0 10px' }} /* onClick={() => history.push('/home')} */>reset</Button>
                        <Button disabled variant='contained' color='secondary' size='small' sx={{ margin: '0 10px' }} /* onClick={() => history.push('/home')} */>Save To My Briefcase</Button>
                        <Button variant='contained' color='success' size='small' sx={{ margin: '0 10px' }} onClick={saveArticle}>Publish</Button>
                    </Box>
                </Box>
            }

            {/* PUBLISH AD SUCCESS DIALOG */}
            <Dialog
                open={openPublishAdSuccessModal}
                onClose={() => setOpenPublishAdSuccessModal(true)}
            >
                <DialogTitle>Ad Published</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Ad has been published successfully.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenPublishAdSuccessModal(false)} variant='contained' color='primary'>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>

            {/* MANAGE CATEGORIES DIALOG */}
            <Dialog
                open={openCategoryModal}
                onClose={() => setOpenCategoryModal(false)}
                maxWidth='lg'
            >
                <Box sx={{
                    columnCount: { xs: 1, sm: 2, md: 3 }, // Adjust columns based on screen size
                    columnGap: '20px', // Smaller gap between columns
                    padding: 1,
                    margin: 0
                }} boxShadow={5}>
                    {assignedMasterCategoriesSubCategoriesTree.map(category => (
                        <Box sx={{
                            backgroundColor: colors.blueGrey[50],
                            borderRadius: '8px',
                            marginBottom: '15px', // Gap between cards in the same column
                            breakInside: 'avoid', // Prevents breaking within columns
                            padding: 2,
                            display: 'inline-block', // Required for column layout
                            width: '90%', // Ensures full width within the column
                        }}>
                            <ManageCategoriesComp
                                category={category}
                                assignedMasterCategoriesSubCategoriesTree={assignedMasterCategoriesSubCategoriesTree}
                                setAssignedMasterCategoriesSubCategoriesTree={setAssignedMasterCategoriesSubCategoriesTree} />
                        </Box>
                    ))}
                </Box>
            </Dialog>

            {/* MANAGE MACRO-INDICATORS DIALOG */}
            {/* <Dialog
                open={openIndicatorsModal}
                onClose={() => setOpenIndicatorsModal(false)}
                maxWidth='lg'
            >
                <Box sx={{
                    columnCount: { xs: 1, sm: 2, md: 3 }, // Adjust columns based on screen size
                    columnGap: '20px', // Smaller gap between columns
                    padding: 1,
                    margin: 0
                }} boxShadow={5}>
                    {assignedMasterMacroIndicatorTree.map(indicator => (
                        <Box sx={{
                            backgroundColor: colors.blueGrey[50],
                            borderRadius: '8px',
                            marginBottom: '15px', // Gap between cards in the same column
                            breakInside: 'avoid', // Prevents breaking within columns
                            padding: 2,
                            display: 'inline-block', // Required for column layout
                            width: '90%', // Ensures full width within the column
                        }}>
                            <ManageMacroIndicatorsComp
                                indicator={indicator}
                                assignedMasterMacroIndicatorTree={assignedMasterMacroIndicatorTree}
                                setAssignedMasterMacroIndicatorTree={setAssignedMasterMacroIndicatorTree} />
                        </Box>
                    ))}
                </Box>
            </Dialog> */}
        </>
    )
}

export default AddArticle;
